<app-loading-generico [loadingGenerico]="LoadingGenerico"></app-loading-generico>
<div class="navbar-wrapper position-relative">
  <nav class="navbar navbar-light bg-white navbar-sobreposto header-div">
    <div class="navbar-brand" routerLink="/home">
      <div style="display: flex;">
        <img src="/assets/img/logo-novo.png" style="margin-right: 20px;height: 52px;width: 78px" alt="logo alelo">
        <img src="/assets/img/logo-texto.png" style="height: 37px;width: 143px" alt="logo alelo">
      </div>
    </div>
    <div class="navbar-text p-0 pe-lg-5 mt-3 mt-md-0">
      <div class="align-items-center" style="display: flex;margin-right: -15px;margin-left: -15px">
        <div style="margin-right: 15px">
          <p class="bem-vindo">
            Bem vindo, {{nomeEmpresa | camelCase}}
          </p>
          <p class="nome-empresa" routerLink="/selecionar-empresa">{{cnpj | cnpj}}</p>
        </div>
        <div class="navbar-sobreposto" style="border-right: 1px solid #6969694D;"
          [tag]="addTagManagerInteraction('header:icon:click', 'perfil')">
          <span class="dropdown dropdown-perfil text-nowrap">
            <div class="div-icone-perfil">
              <img src="/assets/img/icone-perfil.png" alt="logo alelo">
              <i class="fa fa-caret-down c-primary" aria-hidden="true"></i>
            </div>
            <div class="container-dropdown-perfil">
              <div class="div-dropdown">
                <p class="itens-dropdown"
                  (click)="privacidadeSeguranca()"
                  (keydown.enter)="privacidadeSeguranca()"
                [tag]="addTagManagerInteraction('header:icon:click', 'perfil:privacidade-e-seguranca')">Privacidade e Segurança</p>
              </div>
              <div class="div-dropdown">
                <p class="itens-dropdown" routerLink="/selecionar-empresa"
                  [tag]="addTagManagerInteraction('header:icon:click', 'perfil:trocar-empresa')">
                Trocar Empresa</p>
              </div>

              <div class="div-dropdown">
                <p class="itens-dropdown text-nowrap" routerLink="/condicoes-contratacao"
                  [tag]="addTagManagerInteraction('header:icon:click', 'perfil:condicoes-de-contratacao')">
                Condições de Contratação</p>
              </div>

              <div class="div-dropdown">
                <p class="itens-dropdown text-nowrap"
                  (click)="openPrivacyPolicy()"
                  (keydown.enter)="openPrivacyPolicy()"
                  [tag]="addTagManagerInteraction('header:icon:click', 'perfil:politicas-de-privacidade')">
                Políticas de Privacidade</p>
              </div>
              <hr class="hr" style="margin-top: 5px;margin-bottom: 1px;">
              <div class="div-dropdown">
                <p class="itens-dropdown"
                  (click)="sairDoSistema()"
                  (keydown.enter)="sairDoSistema()"
                  [tag]="addTagManagerInteraction('header:icon:click', 'perfil:sair-do-sistema')">
                  <i class="fa fa-sign-out" aria-hidden="true" style="margin-right: 5px"></i>Sair do sistema</p>
                </div>
              </div>
            </span>
          </div>
          <span class="dropdown dropdown-perfil text-nowrap">
            <div class="div-icone-perfil" style="display: flex">
              <img src="/assets/img/notificacao.png" alt="sino notificacao"
                style="height: 32px;width: 25px;margin-left: 15px;margin-right: 15px;">
              <div class="numero-notificacoes"><span>0</span></div>
            </div>
            <div class="container-dropdown-notificacao">
              <p>Notificações</p>
              <div class="div-dropdown-notificacao" app-notificacoes-dropdown>
              </div>
            </div>
          </span>
        </div>
      </div>
    </nav>
    <div class="navbar navbar-expand-lg navbar-dark bg-primary navbar-sobreposto-2" style="height: 50px">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse header-div bg-primary" id="navbarNavDropdown">
        <div class="align-items-center submenu" >
          <!-- ICONE HOME -->
          <div class="home-img">
            <img src="/assets/img/home.png" routerLink="/home" id="homeAlelo" height="16px" width="21px"
              alt="logo home alelo">
          </div>
          <!-- ITEM CADASTRO -->
          @if ((usuarioPermissaoService.cssPorPermissoes$ | async)?.MenuPermissionsCounter?.Cadastros || (usuarioPermissaoService.cssPorPermissoes$ | async)?.MenuPermissionsCounter['Usuarios de Beneficio']) {
            <div
              >
              <div class="dropdown-custom">
                <p class="itens-menu" [tag]="addTagManagerInteraction('header:button:click', 'cadastro')">Cadastro▾</p>
                <div class="cadastro-triangulo container-dropdown" style="margin-left: -23px;height: 90px;width: 169px"
                  id="cadastroDropdown">
                  <p class="itens-dropdown" routerLink="/dados-empresa"
                    [tag]="addTagManagerInteraction('header:button:click', 'cadastro:dados-da-empresa')"
                    [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.CadastrosDadosDaEmpresa?.Imprimir)">
                  Dados da Empresa</p>
                  <p class="itens-dropdown" [routerLink]="['/usuario-beneficio']"
                    [tag]="addTagManagerInteraction('header:button:click', 'cadastro:usuario-de-beneficios')"
                 [ngClass]="{
                      hidden: !('CadastrosUsuariosDeBeneficio' | usuarioPermissao:'Imprimir' | async)
                      && !('UsuariosDeBeneficioSolicitacao2aVia' | usuarioPermissao:'Imprimir' | async)
                }">
                  Dados do Usuário</p>
                </div>
              </div>
            </div>
          }
          <!-- ITEM RELATÓRIOS -->
          @if ((usuarioPermissaoService.cssPorPermissoes$ | async)?.MenuPermissionsCounter?.Relatorios) {
            <div>
              <div class="dropdown-custom">
                <p class="itens-menu" [tag]="addTagManagerInteraction('header:button:click', 'relatorios')">
                Relatórios▾</p>
                <div class="container-dropdown" style="margin-left: -46px">
                  <p class="itens-dropdown" routerLink="/usuarios-ativos"
                    [tag]="addTagManagerInteraction('header:button:click', 'relatorios:usuarios')"
                    [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.RelatoriosRelatorioDeUsuariosAtivos?.Imprimir)">
                  Usuários</p>
                  <p class="itens-dropdown" routerLink="/relatorio-rota"
                    [tag]="addTagManagerInteraction('header:button:click', 'relatorios:sugestao-de-rota')"
                    [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.RelatoriosSugestaoDeRota?.Imprimir)">
                  Sugestão de Rota</p>
                  <p class="itens-dropdown" routerLink="/relatorio-gerencial-rc"
                    [tag]="addTagManagerInteraction('header:button:click', 'relatorios:gerencial-recarga-certa')"
                    [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.RelatoriosGerencialRecargaCerta?.Imprimir)">
                  Gerencial Recarga Certa</p>
                  <p class="itens-dropdown" routerLink="/informe-rendimentos"
                    [tag]="addTagManagerInteraction('header:button:click', 'relatorios:informe-de-rendimentos')"
                    [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.InformeRendimentos?.Imprimir)">
                  Informe de Rendimentos</p>
                </div>
              </div>
            </div>
          }
          <!-- ITEM PEDIDOS -->
          @if ((usuarioPermissaoService.cssPorPermissoes$ | async)?.MenuPermissionsCounter?.Pedidos) {
            <div>
              <div class="dropdown-custom">
                <p class="itens-menu" [tag]="addTagManagerInteraction('header:button:click', 'pedidos')">Pedidos▾</p>
                <div class="container-dropdown" style="margin-left: -60px;">
                  <p class="itens-dropdown" routerLink="/importador-dados"
                    [tag]="addTagManagerInteraction('header:button:click', 'pedidos:importar-e-realizar-pedidos')"
                    [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.PedidosImportarDadosFazerPedido?.Imprimir)">
                  Realizar Pedidos</p>
                  <p class="itens-dropdown" hidden routerLink="/pedidos-bolsa-credito"
                    [tag]="addTagManagerInteraction('header:button:click', 'pedidos:bolsa-de-credito')">Bolsa de
                  Crédito</p>
                  <p class="itens-dropdown" routerLink="/listar-pedidos"
                    [tag]="addTagManagerInteraction('header:button:click', 'pedidos:listar-pedidos')"
                    [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.PedidosListarPedidos?.Imprimir)">
                    Listar Pedidos
                  </p>
                  <p class="itens-dropdown" routerLink="/listar-pedidos-pos-pago"
                    [tag]="addTagManagerInteraction('header:button:click', 'pedidos:listar-pedidos-pos-pago')"
                    [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.PedidosLiberarPedidosPosPago?.Imprimir)">
                  Listar Pedidos Pós pago</p>
                  <p class="itens-dropdown" routerLink="/demonstrativos-faturas"
                    [tag]="addTagManagerInteraction('header:button:click', 'pedidos:demonstrativo-de-faturas')"
                    [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.PedidosDemonstrativoDeFaturas?.Imprimir)">
                  Demonstrativo de Faturas</p>
                  <p class="itens-dropdown" routerLink="/devolucoes"
                    [tag]="addTagManagerInteraction('header:button:click', 'pedidos:devolucao-deposito-em-conta')"
                    [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.PedidosDevolucoesDepositoEmContaUsuario?.Imprimir)">
                  Devolução Depósito em Conta</p>
                  <p class="itens-dropdown" routerLink="/pedido-estoque-papel"
                    [tag]="addTagManagerInteraction('header:button:click', 'pedidos:estoque-papel')"
                    [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.FazerPedidoAvulso?.Imprimir)">
                  Vale Papel</p>
                </div>
              </div>
            </div>
          }
          <!-- ITEM FERRAMENTAS -->
          <div>
            <div class="dropdown-custom">
              <p class="itens-menu" [tag]="addTagManagerInteraction('header:button:click', 'ferramentas')">
              Ferramentas▾</p>
              <div class="container-dropdown" style="margin-left: -31px;">
                <p class="itens-dropdown" routerLink="/importar-dados-bancarios"
                  [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.FerramentasImportacoes?.Imprimir)"
                  [tag]="addTagManagerInteraction('header:button:click', 'ferramentas:importar-dados-bancarios')">
                Importar Dados Bancários </p>
                <p class="itens-dropdown" routerLink="/operadoras"
                [tag]="addTagManagerInteraction('header:button:click', 'ferramentas:operadoras')">Operadoras</p>
                <p class="itens-dropdown" routerLink="/gerar-planilha-dados"
                  [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.FerramentasGerarPlanilhaDeDados?.Imprimir)"
                  [tag]="addTagManagerInteraction('header:button:click', 'ferramentas:gerar-planilha-de-dados')">
                Gerar Planilha de Dados</p>
              </div>
            </div>
          </div>
          <!-- ITEM EXCLUSIVIDADES -->
          <div>
            <div class="dropdown-custom">
              <p class="itens-menu" [tag]="addTagManagerInteraction('header:button:click', 'exclusividades')">
              Exclusividades▾</p>
              <div class="container-dropdown" style="margin-left: -18px;">
                <p class="itens-dropdown" routerLink="/gerenciar-ocorrencias"
                  [tag]="addTagManagerInteraction('header:button:click', 'exclusividades:gerenciar-ocorrencias')">
                Gerenciar Ocorrências</p>
                <p class="itens-dropdown" routerLink='/contratacao-rota-inteligente'
                  [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.ExclusividadesSugestaoDeRotas?.Imprimir)"
                  [tag]="addTagManagerInteraction('header:button:click', 'exclusividades:contratacao-rota-inteligente')">
                Contratação Rota Inteligente</p>
                <p class="itens-dropdown"
                  (click)="downloadTermoUtilizacao()"
                  (keydown.enter)="downloadTermoUtilizacao()"
                  [tag]="addTagManagerInteraction('header:button:click', 'exclusividades:termo-de-utilizacao')">
                Termo de Utilização</p>
                <a class="itens-dropdown" target="_blank" href='/assets/documentos/MANUAL_SUGESTAO_ROTAS_V7.pdf'
                  [tag]="addTagManagerInteraction('header:button:click', 'exclusividades:manual-sugestao-de-rota')">
                Manual Sugestão de rota</a>
                <p class="itens-dropdown" routerLink='/contratacao-recarga-certa'
                  [ngClass]="$safeNavigationMigration((usuarioPermissaoService.cssPorPermissoes$ | async)?.ExclusividadesRecargaCerta?.Imprimir)"
                  [tag]="addTagManagerInteraction('header:button:click', 'exclusividades:contratacao-recarga-certa')">
                Contratação Recarga Certa</p>
                <p class="itens-dropdown"
                  (click)="downloadTermoAdesao()"
                  (keydown.enter)="downloadTermoAdesao()"
                  [tag]="addTagManagerInteraction('header:button:click', 'exclusividades:termo-de-adesao')">
                Termo de Adesão</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
